import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { selectAddMoreItemToggle } from '../../redux/cart/cart.selector';

import CartButtom from '../cart-button/cart-button.component';
import noImage from '../../assets/food-placeholder.jpg';

import './add-more-items.style.css';

const addMoreItems = ({ addmoreItems, addMoreToggle }) => {
    return (
        <div className={`recommend-container ${addMoreToggle === true ? 'active':''}`} id="addmore" aria-hidden="false">
            <div className="recommend-cards" >

            {addmoreItems.length !== undefined &&  addmoreItems.map((item,index )=> 
                    (
                    <div key={index} className='recommend-card' id={index === 0 ? 'firstchild' : null}>
                        <div style={{ width: '95px', padding: '10px' }}>
                            <img className='recommend-card-image' src={item.image_url?item.image_url:noImage} alt='Thali' />
                        </div>
                        <div className='recommend-card-right'>
                            <div className='recommend-card-title'>
                                <div className={item.food_type === '1' ? 'green' : 'red'} id='recommend'></div>&nbsp;
                                <p className="item-name" >{item.item_name}</p>
                            </div>
                            <div className='recommend-card-detail'>
                                <p style={{ fontSize: '12px' }} >₹{item.price}</p>
                                <div> 
                                    <CartButtom key={item.id} item={item} />
                                </div>
                            </div>
                        </div>
                    </div>
                    )
                )
            }
            </div>
        </div>
    )
}

const mapStateToProps = createStructuredSelector({
    addMoreToggle: selectAddMoreItemToggle,
})

export default connect(mapStateToProps)(addMoreItems);